import { Typography, Box, useTheme } from "@mui/material";
import useStyles from "./styles";

const ErrorFallBack = (props: any) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Box sx={styles.container}>
      <Typography variant="h2" sx={styles.text}>
        Error
      </Typography>
      <Box
        component="img"
        src="errorPage.svg"
        alt="Error symbol"
        sx={{ width: "100%", maxWidth: 300 }}
      />
      <Typography variant="h4" sx={styles.textMessage} gutterBottom>
        Ocorreu um erro
      </Typography>
      <Typography variant="h6" sx={styles.textMessage} gutterBottom>
        Tente novamente em alguns instantes, se o error persistir entre em
        contato com a nossa equipe.
      </Typography>
    </Box>
  );
};

export default ErrorFallBack;
